import React, { useEffect } from 'react';

import * as S from './styles';
import { IProps } from './types';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { pointListUrl, activeOrderListUrl, pendingReviewListUrl } from '@src/app/routes';
import { useLazyQuery } from '@apollo/react-hooks';
import { SKIN_TYPE_CONCERN_TAGS } from '@organisms/MyAccountMain/queries';
import { skinTypeConcernTags } from '@organisms/MyAccountMain/__generated__/skinTypeConcernTags';
import { ProductTag } from '@atoms';
import { DeviceContext, deviceType } from '@providers';

const MyAccountMain: React.FC<IProps> = ({
  firstName,
  skinType,
  skinConcern,
  activeOrders,
  pendingReviews,
  availablePoints = 0,
}: IProps) => {
  const [fetchSkinTypeConcernTags, { data, error, loading }] = useLazyQuery<skinTypeConcernTags>(
    SKIN_TYPE_CONCERN_TAGS,
    {
      variables: {
        first: 100,
        skinType,
        skinConcern,
      },
    },
  );
  const isMobile = React.useContext<deviceType>(DeviceContext).isMobile;

  useEffect(() => {
    if (skinType && skinConcern) {
      fetchSkinTypeConcernTags();
    }
  }, []);

  return (
    <S.Wrapper>
      {isMobile ? (
        <S.UserNameSmall>Hello User {firstName}!</S.UserNameSmall>
      ) : (
        <S.UserName>Hello User {firstName}!</S.UserName>
      )}
      {skinType &&
        (isMobile ? (
          <>
            <p>{firstName}'s Skin</p>
            <Row>
              <Col md={8} xs={12}>
                <S.SummaryCard>
                  <Card.Body>
                    <Row>
                      <S.ColBorder md={6} xs={6}>
                        <S.SkinTitleH4>Skin Type</S.SkinTitleH4>
                        <S.SkinValue>{skinType}</S.SkinValue>
                      </S.ColBorder>
                      <Col md={6} xs={6}>
                        <S.SkinTitleH4>Skin Concern</S.SkinTitleH4>
                        <S.SkinValue>{skinConcern}</S.SkinValue>
                      </Col>
                    </Row>
                  </Card.Body>
                </S.SummaryCard>
              </Col>
            </Row>
          </>
        ) : (
          <>
            <p>{firstName}'s Skin</p>
            <Row>
              <Col md={8}>
                <S.SummaryCard>
                  <Card.Body>
                    <Row>
                      <S.ColBorder md={6}>
                        <S.SkinTitleH4>Skin Type</S.SkinTitleH4>
                        <S.SkinValue>{skinType}</S.SkinValue>
                      </S.ColBorder>
                      <Col md={6}>
                        <S.SkinTitleH4>Skin Concern</S.SkinTitleH4>
                        <S.SkinValue>{skinConcern}</S.SkinValue>
                      </Col>
                    </Row>
                  </Card.Body>
                </S.SummaryCard>
              </Col>
            </Row>
          </>
        ))}
      <S.Subtitle>Summary</S.Subtitle>
      <Container>
        <Row>
          <S.SummaryCard>
            <Card.Body>
              <Row>
                <S.ColBorder md={4} xs={4}>
                  <S.SummaryTitleA to={activeOrderListUrl}>
                    <S.SummaryTitleH4>Active Orders &gt;</S.SummaryTitleH4>
                  </S.SummaryTitleA>
                  <S.SummaryValue>{activeOrders}</S.SummaryValue>
                </S.ColBorder>
                <S.ColBorder md={4} xs={4}>
                  <S.SummaryTitleA to={pendingReviewListUrl}>
                    <S.SummaryTitleH4>Pending Reviews &gt;</S.SummaryTitleH4>
                  </S.SummaryTitleA>
                  <S.SummaryValue>{pendingReviews}</S.SummaryValue>
                </S.ColBorder>
                <Col md={4} xs={4}>
                  <S.SummaryTitleA to={pointListUrl}>
                    <S.SummaryTitleH4>Available Points &gt;</S.SummaryTitleH4>
                  </S.SummaryTitleA>
                  <S.SummaryValue>{availablePoints}</S.SummaryValue>
                </Col>
              </Row>
            </Card.Body>
          </S.SummaryCard>
        </Row>
      </Container>
      {data && data?.skintypeConcernTags?.totalCount > 0 ? (
        <>
          <hr />
          <S.Subtitle>Recommendation for my skin type</S.Subtitle>
        </>
      ) : (
        <></>
      )}
      {data &&
        data?.skintypeConcernTags?.edges?.map((edge, i) => {
          const tag = edge.node.tag;
          return <ProductTag tagName={tag.name} tagId={tag.id} key={i} />;
        })}
    </S.Wrapper>
  );
};

export { MyAccountMain };
